/** Upstream retrieval metadata only; this is not reporting certification. */
export interface CreativePerformanceSnapshotMetadata {
  fetchedAt: string | null;
  version: number;
  state: "idle" | "refreshing" | "error";
  stale: boolean;
  error: string | null;
}
export const CREATIVE_SNAPSHOT_HEADER = "X-Creative-Performance-Snapshot";
export const CREATIVE_SNAPSHOT_REFRESH_HEADER = "X-Creative-Performance-Refresh";
export const CREATIVE_SNAPSHOT_CONFIG = {
  freshTodayMs: 10 * 60_000,
  freshHistoricalMs: 60 * 60_000,
  retentionMs: 7 * 24 * 60 * 60_000,
  leaseMs: 45_000,
  coldWaitMs: 35_000,
  backoffMs: 60_000,
  maxConcurrent: 3,
  maxPayloadBytes: 8 * 1024 * 1024,
} as const;
export function creativeSnapshotFresh(fetchedAt: Date | string | null, until: string, now = Date.now()) {
  const at = fetchedAt ? new Date(fetchedAt).getTime() : NaN;
  const window = until >= new Date(now).toISOString().slice(0, 10)
    ? CREATIVE_SNAPSHOT_CONFIG.freshTodayMs : CREATIVE_SNAPSHOT_CONFIG.freshHistoricalMs;
  return Number.isFinite(at) && at <= now && now - at < window;
}
export function combineCreativeSnapshots(items: CreativePerformanceSnapshotMetadata[]): CreativePerformanceSnapshotMetadata {
  const dates = items.map(item => item.fetchedAt).filter((at): at is string => !!at).sort();
  return {
    fetchedAt: dates[0] ?? null,
    version: items.reduce((sum, item) => sum + item.version, 0),
    state: items.some(item => item.state === "refreshing") ? "refreshing"
      : items.some(item => item.state === "error") ? "error" : "idle",
    stale: items.some(item => item.stale),
    error: items.find(item => item.error)?.error ?? null,
  };
}
